import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { useCallback, useMemo, useState } from 'react';
import MoreToolsDropdown from './MoreToolsDropDown';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MoreToolsButton({
  allowlistingOpen,
  canSeeAdditionalMoreToolsContent,
  hasIlsListsWriteScope,
  hasListsViewScope,
  hasListsWriteScope,
  isFree,
  isStarter,
  limitsOpen,
  AsyncMoreToolsModalContainer,
  router,
  selectedTab,
  setComparisonToolReturnLocation,
  staticListLimitReached,
  tracker,
  updateQueryAndPathParams
}) {
  const [hardBounceListOpen, setHardBounceListOpen] = useState(false);
  const [importOptOutModalOpen, setImportOptOutModalOpen] = useState(false);
  const [importContactsOpen, setImportContactsOpen] = useState(false);
  const [hardBounceListType, setHardBounceListType] = useState('');
  const trackMoreToolsClick = itemName => {
    trackDashboardInteraction({
      clickMoreTools: itemName
    });
  };
  const onHardBounceListClick = useCallback(type => {
    trackMoreToolsClick(`${type}-hard-bounce-list`);
    setHardBounceListOpen(true);
    setHardBounceListType(type);
  }, []);
  const onImportOptOutClick = useCallback(() => {
    trackMoreToolsClick('import-opt-out');
    setImportOptOutModalOpen(true);
  }, []);
  const onImportContactsClick = useCallback(() => {
    trackMoreToolsClick('import-contacts');
    setImportContactsOpen(true);
  }, []);
  const closeAllModals = useCallback(() => {
    setImportContactsOpen(false);
    setImportOptOutModalOpen(false);
    setHardBounceListOpen(false);
    setHardBounceListType('');
  }, []);
  const onManageAllowlistingClick = useCallback(() => {
    trackMoreToolsClick('manage-whitelisting');
    router.navigateTo('/manage/whitelisting');
  }, [router]);
  const onManageSendingLimitsClick = useCallback(() => {
    trackMoreToolsClick('manage-sending-limits');
    router.navigateTo('/manage/limits');
  }, [router]);
  const preloadModals = useCallback(() => {
    AsyncMoreToolsModalContainer.preload();
  }, [AsyncMoreToolsModalContainer]);
  const hasOpenModal = hardBounceListOpen || importOptOutModalOpen || allowlistingOpen || limitsOpen || importContactsOpen;
  const proOrEnt = !(isFree || isStarter);
  const renderTools = () => /*#__PURE__*/_jsx(Dropdown, {
    "data-test-id": "email-tools-dropdown-button",
    buttonUse: "secondary",
    buttonSize: "small",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "EmailComponents.manage.moreTools.emailTools"
    }),
    children: /*#__PURE__*/_jsx(MoreToolsDropdown, {
      canSeeAdditionalMoreToolsContent: canSeeAdditionalMoreToolsContent,
      hasIlsListsWriteScope: hasIlsListsWriteScope,
      hasListsViewScope: hasListsViewScope,
      hasListsWriteScope: hasListsWriteScope,
      isFree: isFree,
      isStarter: isStarter,
      selectedTab: selectedTab,
      setComparisonToolReturnLocation: setComparisonToolReturnLocation,
      tracker: tracker,
      updateQueryAndPathParams: updateQueryAndPathParams,
      onHardBounceListClick: onHardBounceListClick,
      onImportContactsClick: onImportContactsClick,
      onImportOptOutClick: onImportOptOutClick,
      onManageAllowlistingClick: onManageAllowlistingClick,
      onManageSendingLimitsClick: onManageSendingLimitsClick,
      preloadModals: preloadModals,
      proOrEnt: proOrEnt,
      staticListLimitReached: staticListLimitReached,
      trackMoreToolsClick: trackMoreToolsClick
    })
  });
  const renderToolModal = useMemo(() => hasOpenModal && /*#__PURE__*/_jsx(AsyncMoreToolsModalContainer, {
    closeAllModals: closeAllModals,
    hardBounceListOpen: hardBounceListOpen,
    hardBounceListType: hardBounceListType,
    importContactsOpen: importContactsOpen,
    importOptOutModalOpen: importOptOutModalOpen,
    limitsOpen: limitsOpen,
    whitelistingOpen: allowlistingOpen
  }), [AsyncMoreToolsModalContainer, allowlistingOpen, closeAllModals, hardBounceListOpen, hardBounceListType, hasOpenModal, importContactsOpen, importOptOutModalOpen, limitsOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderTools(), renderToolModal]
  });
}
export default MoreToolsButton;